var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreatedImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#4F46E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#EAE9FF",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 18V15.7514L15.4684 8.29331C15.5649 8.19682 15.6745 8.12381 15.7971 8.07429C15.9195 8.02476 16.0461 8 16.1768 8C16.3118 8 16.4413 8.02476 16.5651 8.07429C16.6889 8.12381 16.8025 8.20026 16.9059 8.30364L17.7067 9.11463C17.8101 9.21112 17.8848 9.32127 17.9309 9.44508C17.977 9.56901 18 9.69842 18 9.83334C18 9.95726 17.977 10.0805 17.9309 10.2029C17.8848 10.3255 17.8101 10.4385 17.7067 10.5419L10.2486 18H8ZM16.0552 10.7687L17.0006 9.82318L16.1768 8.99937L15.2313 9.94477L16.0552 10.7687Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatedImg);
export default __webpack_public_path__ + "static/media/created_img.f84652749cabd30b5b1bed870913e8b2.svg";
export { ForwardRef as ReactComponent };